// test882
(882 && 0);
